import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Input from '../../components/Input';

const ContactRequests = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addTeacherModal, setAddTeacherModal] = useState(false);
  const [cnicModal, setCnicModal] = useState(false);
  const [selectedCnicImage, setSelectedCnicImage] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = teachers.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  const contactFrom = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true);
    fetch('https://quran-backend-theta.vercel.app/v1/user/contact', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log(data);
        
        setTeachers(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    contactFrom();
  }, []);

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Contact!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');

        const requestOptions = {
          method: 'DELETE',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(`https://quran-backend-theta.vercel.app/v1/user/contact/${id}`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);

            if (data.success === true) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your contact request has been deleted.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                contactFrom();
              });
            }
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error!',
              text: 'An error occurred while deleting the note.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });
      }
    });
  };


  const handleRead = (id) => {
  
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Accept', 'application/json');

      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(`https://quran-backend-theta.vercel.app/v1/admin/mark-read/${id}`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let data = JSON.parse(result);

          if (data.success === true) {
           
              contactFrom();
            
          }
        })
        .catch((error) => {
          console.error(error);
          
        });
    
  };

  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <div className="flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Contact Requests</h2>
          <p className="text-[#1C1D1D]">Here are the details of all job applications</p>
        </div>
        <div className="cursor-pointer">
          {/* <img
            onClick={() => setAddTeacherModal(true)}
            src={require('../../assets/image/add.png')}
            alt=""
          /> */}
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <p>Loading...</p>
        </div>
      ) : (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead className="">
                        <tr className="rounded-lg whitespace-nowrap">
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            S No.
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Name
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Email
                          </th>

                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Phone no
                          </th>

                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Message
                          </th>

                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Read / Delete
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCourses?.map((teacher, index) => (
                          <tr key={teacher?._id} className=" shadow-lg mt-6 rounded-lg">
                            <td className={`align-middle ${teacher?.read===true?'bg-white':'bg-gray-200'} text-sm font-normal px-6 py-3 whitespace-nowrap text-center`}>
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {index + 1}
                              </span>
                            </td>
                            <td className={`text-sm ${teacher?.read===true?'bg-white':'bg-gray-200'} font-normal text-center px-6 py-4 whitespace-nowrap`}>
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {teacher?.name}
                              </span>
                            </td>
                            <td className={`align-middle  ${teacher?.read===true?'bg-white':'bg-gray-200'}  text-sm font-normal px-6 py-4 whitespace-nowrap text-left`}>
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.email}
                              </span>
                            </td>

                            <td className={`align-middle  ${teacher?.read===true?'bg-white':'bg-gray-200'}  text-sm font-normal px-6 py-4 whitespace-nowrap text-left`}>
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.phone}
                              </span>
                            </td>
                            <td className={`align-middle  ${teacher?.read===true?'bg-white':'bg-gray-200'}  text-sm font-normal px-6 py-4 whitespace-nowrap text-left`}>
                              <span className="bg-green-200 text-base text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.message}
                              </span>
                            </td>

                            <td className={`align-middle  ${teacher?.read===true?'bg-white':'bg-gray-200'}  text-sm font-normal px-6 py-4 whitespace-nowrap text-left`}>
                              <div className=' flex items-center justify-end gap-2.5'>
                                {teacher?.read===true?
                                 null:  <button onClick={()=>handleRead(teacher?._id)} className=' text-white  bg-secondary px-3 py-1 rounded'>Read</button>
                              }
                              <div className=' w-10'>
                              <img
                                onClick={() => handleDeleteClick(teacher?._id)}
                                className=" cursor-pointer  w-5"
                                src={require('../../assets/image/del.png')}

                                alt=""
                              />
                              </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {cnicModal && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-sm w-full">
              {selectedCnicImage && (
                <img src={selectedCnicImage} alt="CNIC" className="w-full h-auto mb-4" />
              )}
              <div className="flex justify-end ">
                <button
                  onClick={() => setCnicModal(false)} // Replace with your state management to close the modal
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default ContactRequests;
